<ng-container *ngIf="jobs && jobs.length > 0">
    <h3>{{ title }}</h3>

    <div class="job-list">
        <ng-container *ngFor="let job of jobs">
            <div class="job">
                <div>
                    <img
                        *ngIf="job.status === JobStatusEnum.Closed"
                        src="assets/icons/job-done.svg"
                        alt="Job completed"
                    />
                    <img
                        *ngIf="job.status === JobStatusEnum.Rejected"
                        src="assets/icons/job-failed.svg"
                        alt="Job failed"
                    />
                    <img
                        *ngIf="
                            job.status !== JobStatusEnum.Closed &&
                            job.status !== JobStatusEnum.Rejected
                        "
                        src="assets/icons/job-in-progress.svg"
                        alt="Job in progress"
                    />
                </div>
                <div>{{ job.id }}</div>
                <div class="font-smaller font-faded">
                    <span>{{ job.startDate | date : 'dd.MM.yyyy, HH:mm' }}</span>
                </div>
                <div class="font-smaller font-faded">{{ job.progress }}%</div>
                <div class="font-faded">{{ appendTypeToName(job) }}</div>
            </div>
        </ng-container>
    </div>
</ng-container>
